module.exports = __webpack_public_path__ + "static/img/x.234c2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x.png
// module id = 264
// module chunks = 1